<template>
  <div>
    <div class="srch_area">
      <h3>문전 약국 병원 선택</h3>
      <div class="srchfrm">
        <input class="srchfrm_inpt" type="text" v-model="search_name" v-on:keyup.enter="searchHospital()">
        <button class="srchfrm_sbmt" type="submit" @click="searchHospital()"></button>
      </div>
    </div>
    <div class="lst_area">
      <div class="lst" v-if="hospital_list.length > 0"> <!-- 병원이 있을떄 -->
        <ul>
          <!-- <li @click="select_row()">
            <a href="#" title="">삭제</a>
          </li> -->
          
          <li v-for="hospital in hospital_list" @click="select_row(hospital)" :key="hospital.dr_id">
            <a href="#" title="">{{hospital.dr_name}}({{hospital.hosp_name}})</a>
          </li>
        </ul>
      </div>
      <div class="no_lst" v-else> <!-- 병원이 없을떄 -->
        <p>검색된 병원이 없습니다.</p>
      </div>
    </div>
  </div>
</template>

<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'doorhospital',
    
    data () {
      return {
        hospital_list: [],
        search_name: null,
      }
    },
    methods: {
      select_row(hospital){
        this.$emit('closeEvent', hospital);
      },
      async searchHospital(){
        let params = {
        }

        if(this.search_name){
          params.search_name = this.search_name;
        }

        await this.axios({
          method: 'get',
          url: '/pharmacist/door_hospital',
          params: params,
        }).then((response) => {
          // console.log(response);
          if(!response.data.has_error){ //성공  
            if(response.data.resp.list){
              this.hospital_list = response.data.resp.list;
            }
          }else{ //실패

          }
        }).catch((error) => {
            console.log('error!: ', error);
        }).finally(() => {
            
        });
      },
    },
    computed: {
      // ...mapState(['account'])
    },
    mounted () {
    },
    components: {
    }
  }
</script>

<style scoped>
  .srch_area{padding:40px 13px 40px; border-bottom:3px solid #eee;  background:#f5f6fa; text-align:center;}
  .srch_area h3{margin-bottom:30px; font-size:17px;}
  .srchfrm{position:relative; overflow:hidden; height:40px; padding:0 38px 0 0; border:1px solid #d4d4d4; box-sizing:border-box;}
  .srchfrm:before{content:""; position:absolute; top:7px; right:38px; height:24px; width:1px; background:#999;}
  .srchfrm_inpt{display:block; width:100%; height:38px; padding:0; border:0; padding:0 10px; box-sizing:border-box;}
  .srchfrm_sbmt{position:absolute; width:38px; height:38px; top:calc(50% - 19px); right:0; background:#fff; cursor:pointer; border: 0;}
  .srchfrm_sbmt:before{position:absolute; content:''; width:15px; height:15px; top:calc(50% - 9px); left:calc(50% - 9px); border-radius:50%; box-shadow:0 0 0 2px #999;}
  .srchfrm_sbmt:after {position:absolute; content:''; width:8px; height:6px; top:calc(50% + 6px); left:calc(50% + 2px); border-top:solid 2px #999; transform:rotate(45deg);} 
  .lst_area{font-size:16px; color:#5a5a5a;}
  .lst_area .no_lst{padding:30px 0; text-align:center;}
  .lst_area .lst li{border-bottom:1px solid #e7e7e7;}
  .lst_area .lst li a{display:block; height:45px; line-height:45px; padding:0 20px; font-weight:bold; color:#5a5a5a;}
</style>